import { Layout } from 'components/layout';
import React from 'react';

export const Parking = () => {
  return (
    <section className="mt-[100px] font-open-sans screen-900:mt-6">
      <Layout.Container>
        <div className="px-[33px]">
          <h3 className="uppercase text-plt-black font-bold text-[32px] text-center">
            Подземный паркинг
          </h3>
          <p className="text-center text-xl text-plt-black font-semibold mt-10 max-w-[948px] mx-auto screen-900:mt-6 screen-900:text-sm">
            Для автовладельцев предусмотрен собственный тёплый подземный паркинг
            с доступом из лифта и дополнительным входом с
            улицы.
          </p>
          <img
            className="max-h-[400px] w-full object-cover rounded-[40px] mt-10"
            src="/assets/images/png/parking.png"
            alt=""
          />
        </div>
      </Layout.Container>
    </section>
  );
};
